


























import {Component, Vue} from "vue-property-decorator";
import DeviceList from "@/components/device/DeviceList.vue";
import DevicesUnderConfigurationSection from "@/components/device/DevicesUnderConfigurationSection.vue";
import GroupDownlinksQueueSection from "@/components/device/GroupDownlinksQueueSection.vue";
import AbeewayTrackingGroupConfiguration from "@/components/device/configuration/AbeewayTrackingGroupConfiguration.vue";
import {CoreClient, curCoreClient} from "@/services/CoreClient";
import SectionHeader from "@/components/SectionHeader.vue";
import {Device} from "@/types/core";
import NsenGroupConfiguration from "@/components/device/configuration/nsen/NsenGroupConfiguration.vue";

@Component({
  components: {
    SectionHeader,
    AbeewayTrackingGroupConfiguration,
    NsenGroupConfiguration,
    DevicesUnderConfigurationSection,
    DeviceList,
    GroupDownlinksQueueSection}
})
export default class GroupConfigure extends Vue {

  group:string = '';
  devices:Device[] = [];
  bus = new Vue({});
  errorMsg:string = '';

  // internal dependencies
  private coreClient:CoreClient = curCoreClient;

  created() {
    this.group = this.$route.params.groupId as string;
  }

  async mounted() {
    await this.loadInfo();
    await this.loadDevices();
  }

  async loadInfo() {
    const reply = await this.coreClient.getInfo();

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.errorMsg = `Unable to retrieve user info: ${reply.errorMsg}`;
  }

  async loadDevices() {
    const reply = await this.coreClient.getDevicesInGroup({
      skip: 0,
      limit: 100,
      groupIdList: this.group,
    });

    if (reply.httpCode === 403) {
      return this.$router.push({name: 'login'});
    }

    if (reply.errorMsg) {
      return this.errorMsg = `Unable to retrieve devices for the group: ${reply.errorMsg}`;
    }

    if ( reply.deviceList ) {
      this.devices = reply.deviceList;
    }
  }

  async refresh() {
    this.bus.$emit('refresh');
  }

  back() {
    return this.$router.push({ name: 'assets'});
  }

  getGroupName(groupId: string):string {
    return groupId.replace(/^neura\./, '');
  }

  get showAbeewayTrackingGroupConfiguration():boolean {
    if ( this.devices.length > 0 ) {
      return this.devices[0].deviceType === 'abeewaySmartBadge';
    }
    return false;
  }

  get showNsenGroupConfiguration():boolean {
    if ( this.devices.length > 0 ) {
      return this.devices[0].deviceType?.startsWith('nsenMk2');
    }
    return false;
  }

  get topIconList():any {
    let retList = [
      {name:'arrow-left', title:'back', event:'back', alert: false},
      {name:'sync-alt', title:'refresh', event:'refresh'},
    ];

    return retList;
  }
}
